import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import {Operacao} from '../model/Operacao';

@Injectable({
  providedIn: 'root'
})
export class OprecaoService {

  private BASE_URL = './rest/operacao';

  constructor(private http: HttpClient) {
  }

  obterOperacao(idPac: number): Observable<Operacao> {
    return this.http.get<Operacao>(`${this.BASE_URL}/busca-por-id-pac/${idPac}`, blockUi()).pipe();
  }

}
